// Temporary lock list for events that should not be editable.
// Remove this file, the JSON, and all references once no longer needed.
import lockedEventsData from './editLockedEvents.json';

interface LockedEventRecord {
  axon_event_id: number;
  [key: string]: unknown;
}

const EDIT_LOCKED_EVENT_IDS = new Set<number>(
  (lockedEventsData.records as LockedEventRecord[]).map(r => r.axon_event_id)
);

export const EDIT_LOCKED_MESSAGE =
  "This appointment can't be edited right now. Please contact IT support if you need assistance.";

export const isEditLockedEvent = (eventId?: number): boolean =>
  eventId != null && EDIT_LOCKED_EVENT_IDS.has(eventId);
